/** CustomEvent name for duna-template-to-events wizard (copy / edit / delete). */
export const DUNA_TEMPLATES_EVENT = 'duna-templates-admin';
